import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from "app/util/tokenInterceptor";

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule, MatIconModule } from '@angular/material';
// import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { FuseMessageDialogComponent } from '@fuse/components/message-dialog/message-dialog.component';

import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { fuseConfig } from 'app/fuse-config';
import { UserIdleModule } from 'angular-user-idle';

import { SnackbarComponent } from 'app/layout/components/snackbar/snackbar.component';

// import { FakeDbService } from 'app/fake-db/fake-db.service';
import { AppComponent } from 'app/app.component';
import { AppStoreModule } from 'app/store/store.module';
import { LayoutModule } from 'app/layout/layout.module';

import { MAT_DATE_LOCALE } from '@angular/material';
import { PagMantenimientoComponent } from './pag-mantenimiento/pag-mantenimiento.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthGuard } from 'app/util/auth.guard.ts';
import { ValidacionsesionComponent } from './validacionsesion/validacionsesion.component';
import { RedirectComponent } from './redirect.component';
import { InformesMensualesComponent } from './modules/misprocesos/informes-mensuales/informes-mensuales.component';


const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: './login/login.module#LoginModule'
    },

    { path: 'protected-route', component: ValidacionsesionComponent, canActivate: [AuthGuard] },

    {
        path: 'apps',
        loadChildren: './main/apps/apps.module#AppsModule'
    },
    {
        path: 'misprocesos',
        loadChildren: './main/misprocesos/misprocesos.module#MisprocesosModule'
    },
    {
        path: 'rrhh',
        loadChildren: './main/rrhh/rrhh.module#RrhhModule'
    },
    {
        path: 'jefatura',
        loadChildren: './main/jefatura/jefatura.module#JefaturaModule'
    },
    {
        path: 'reportes',
        loadChildren: './main/reportes/reportes.module#ReportesModule'
    },
    {
        path: 'mantenedor',
        loadChildren: './main/mantenedor/mantenedor.module#MantenedorModule'
    },
    {
        path: 'abastecimiento',
        loadChildren: './main/abastecimiento/abastecimiento.module#AbastecimientoModule'
    },
    {
        path: '**',
        redirectTo: 'apps/dashboards/resumen'
    }
];


@NgModule({
    declarations: [
        AppComponent,
        FuseConfirmDialogComponent,
        FuseMessageDialogComponent,
        SnackbarComponent,
        PagMantenimientoComponent,
        ValidacionsesionComponent,
        RedirectComponent,
        InformesMensualesComponent,

    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),
        // InMemoryWebApiModule.forRoot(FakeDbService, {
        //     delay: 0,
        //     passThruUnknownUrl: true
        // }),

        // Material moment date module
        MatMomentDateModule,

        NgxUiLoaderModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        AppStoreModule,
        MatDialogModule,

        // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
        // Default values: `idle` is 600 (10 minutes), `timeout` is 300 (5 minutes) 
        // and `ping` is 120 (2 minutes).
        UserIdleModule.forRoot({ idle: 600, timeout: 300, ping: 120 })
    ],
    //local days
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            // useFactory: function(injector: Injector) {
            //     return new AuthInterceptor(injector);
            // },
            multi: true
        },
        AuthGuard
    ],
    bootstrap: [
        AppComponent
    ],
    entryComponents: [
        FuseConfirmDialogComponent,
        FuseMessageDialogComponent,
        SnackbarComponent,
        PagMantenimientoComponent
    ]
})
export class AppModule {
}
